import _ from 'lodash';

export const deleteAllCookies = () => {
  var cookies = document.cookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf('=');
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }
};

export const getCookies = (): Record<string, any> => {
  const cookieKeyRegex = /^(.+)=/g;
  const cookieValRegex = /=(.+)$/g;
  const cookieArray = decodeURIComponent(document.cookie).split(';');
  if (cookieArray[0] !== '') {
    const cookieObject = _.reduce(
      cookieArray,
      (object, value) => {
        const key = (value as any).match(cookieKeyRegex)[0].replace('=', '').replace(' ', '');
        const val = (value as any).match(cookieValRegex)[0].replace('=', '').replace(' ', '');
        return Object.assign(object, { [key]: val });
      },
      {}
    );
    return cookieObject;
  }
  return {};
};
